import React from 'react';

import Radio from '@mui/material/Radio';
import { styled } from '@mui/material/styles';

import { theme as staticTheme } from '../../theme';
import { useTheme } from '../styles/styles';

const DisabledUncheckedIcon = styled('span')(({ theme }) => ({
  width: 18,
  height: 18,
  borderRadius: '50%',
  border: `2px solid ${
    theme.background?.scrollbar || staticTheme.colors.border.neutral
  }`,
  backgroundColor:
    theme.background?.surface || staticTheme.custom?.disabledRadioBg,
  display: 'inline-block',
  boxSizing: 'border-box',
}));

interface CustomRadioProps {
  checked?: boolean;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  name?: string;
}

export const CustomRadio: React.FC<CustomRadioProps> = ({
  checked,
  disabled,
  onChange,
  value,
  name,
}) => {
  const theme = useTheme();

  return (
    <Radio
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      value={value}
      name={name}
      icon={disabled ? <DisabledUncheckedIcon /> : undefined}
      // checkedIcon={disabled ? <Icon name={'DisabledChecked'} /> : undefined}
    />
  );
};
